import { supabase } from "@/integrations/supabase/client";

/** Job ids the user has saved — cheap enough to fetch as a set. */
export async function fetchSavedJobIds(userId: string): Promise<Set<string>> {
  const { data, error } = await supabase
    .from("saved_jobs")
    .select("job_id")
    .eq("user_id", userId);
  if (error) throw error;
  return new Set((data ?? []).map((r) => r.job_id));
}

export async function saveJob(userId: string, jobId: string): Promise<void> {
  const { error } = await supabase
    .from("saved_jobs")
    .upsert({ user_id: userId, job_id: jobId }, { onConflict: "user_id,job_id" });
  if (error) throw error;
}

export async function unsaveJob(userId: string, jobId: string): Promise<void> {
  const { error } = await supabase
    .from("saved_jobs")
    .delete()
    .eq("user_id", userId)
    .eq("job_id", jobId);
  if (error) throw error;
}

export interface SavedJobRow {
  job_id: string;
  created_at: string;
  job_posts: {
    id: string;
    slug: string | null;
    title: string;
    shift_date: string;
    shift_start_time: string;
    shift_end_time: string;
    compensation: number | null;
    status: string;
    hospital_profiles: { hospital_name: string | null; city: string | null } | null;
  } | null;
}

export async function fetchSavedJobs(userId: string): Promise<SavedJobRow[]> {
  const { data, error } = await supabase
    .from("saved_jobs")
    .select(
      `job_id, created_at,
       job_posts (
         id, slug, title, shift_date, shift_start_time, shift_end_time,
         compensation, status,
         hospital_profiles ( hospital_name, city )
       )`
    )
    .eq("user_id", userId)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data ?? []) as unknown as SavedJobRow[];
}
